export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSED_NAV';
export const CHANGE_LOCALE = 'CHANGE_LOCALE';
export const SIDE_NAV_STYLE_CHANGE = 'SIDE_NAV_STYLE_CHANGE';
export const NAV_TYPE_CHANGE = 'NAV_TYPE_CHANGE';
export const TOP_NAV_COLOR_CHANGE = 'TOP_NAV_COLOR_CHANGE';
export const HEADER_NAV_COLOR_CHANGE = 'HEADER_NAV_COLOR_CHANGE';
export const TOGGLE_MOBILE_NAV = 'TOGGLE_MOBILE_NAV';
export const SWITCH_THEME = 'SWITCH_THEME';
export const DIRECTION_CHANGE = 'DIRECTION_CHANGE';
export const BTN_COLOR_PRIMARY = 'BTN_COLOR_PRIMARY';
export const BTN_COLOR_SECONDARY = 'BTN_COLOR_SECONDARY';
export const MENU_COLOR_BG = 'MENU_COLOR_BG'
export const MENU_COLOR_ITEM = 'MENU_COLOR_ITEM'
export const MENU_COLOR_ITEM_ACTIVE = 'MENU_COLOR_ITEM_ACTIVE'
export const MENU_COLOR_ITEM_HOVER = 'MENU_COLOR_ITEM_HOVER'
export const MENU_UPDATE_COLORS = 'MENU_UPDATE_COLORS'

